import React, { useState } from 'react';
import { getFlag, setFlag } from 'services/developer';
import styles from './FlagRow.module.scss';
import Switch from 'react-switch';

interface FlagRowProps {
  flagName: string;
  flagDesc: string;
  flagKey: string;
}

export const FlagRow: React.FC<FlagRowProps> = ({ flagName, flagDesc, flagKey }) => {
  const [, forceUpdate] = useState(0);
  return (
    <div className={styles.Row}>
      <div>
        <div className={styles.FlagName}>{flagName}</div>
        <br />
        <div className={styles.FlagDesc}>{flagDesc}</div>
      </div>
      <div className={styles.ToggleContainer}>
        <Switch
          onChange={() => {
            setFlag(flagKey, !getFlag(flagKey));
            //@ts-ignore
            forceUpdate((n) => !n);
          }}
          checked={getFlag(flagKey)}
        />
      </div>
    </div>
  );
};
